import httpManager from "@/app/shared/utils/httpManager";

/**
 * Obtener un canal
 *
 * @param {Object} channelCustomerId Id del identificador a obtener
 *
 * @return {Promise<Object>} Datos del identificador
 */
export default async function (channelCustomerId) {
  const response = await httpManager.get(`/channels/channel-customer/${channelCustomerId}/`);
  return response?.data;
}
